import { Pipe, PipeTransform } from '@angular/core';
import { WeightUnitsEnum } from '../enums/weight-units.enum';
import convertWeight from '../helpers/convert-weight';

@Pipe({
  name: 'convertWeight',
})
export class ConvertWeightPipe implements PipeTransform {
  transform(value: number | string, fromUnit = WeightUnitsEnum.G, toUnit = WeightUnitsEnum.KG): string | number {
    let result = value;
    if (value) {
      result = convertWeight(value, fromUnit, toUnit).toFixed(2);
    }
    return result === 'NaN' || !result ? '-' : result;
  }
}
